import { Button } from "@mui/material";
import React, { useEffect, useState, useContext, useRef } from "react";
import MyContext from "../context/MyContext";
import TickerContext from "../context/ticker";
import ProjectContext from "../context/ProjectContext";
import swal from "sweetalert";
import InputRange from "react-input-range";

function Wmark() {
  const {
    slides,
    setslides,
    setClear,
    changes,
    CurrentProject,
    setCurrentProject,
    setDeafultLoader,
    DeafultLoader,
    setchanginCanvasSize,
    setchanges,
    projectEditorZoom,
    setwatermark,
    watermark,
  } = useContext(ProjectContext);

  const {
    setLayersData,
    LayersData,
    TextCategories,
    setTextCategories,
    setBackgrounds,
    timelineZoomVal,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    calculateWidthByDuration,
    Tl_TotalTime,
    ChangeCount,
    seteditableObject,
    setChangeCount,
    EditorZoom,
  } = useContext(MyContext);
  const { TickerPosition } = useContext(TickerContext);
  const ImageUploderRef = useRef(null);
  const [logoAdded, setlogoAdded] = useState(watermark.added);
  const [logoSrc, setlogoSrc] = useState(watermark.src);
  const [rangeValue, setrangeValue] = useState(watermark.opacity);
  const tempText = (TextString, fontSize) => {
    let percentage = 497 / 1024;
    fontSize = parseInt(fontSize * percentage);

    let span = document.createElement("span");
    span.id = "tempText";
    span.style.fontWeight = TextString === "ToonsRights" ? "bold" : "normal";
    span.style.color = "#333333";
    span.style.fontFamily = "Circular";
    span.style.fontSize = fontSize + "px";
    span.style.overflowWrap = "break-word";
    span.style.lineHeight = "normal";
    span.style.position = "absolute";
    span.style.left = "0px";
    span.style.top = "0px";

    span.innerHTML = TextString;
    document.getElementsByClassName("EditorParent")[0].appendChild(span);

    let textObj = {
      width:
        TextString === "ToonsRights"
          ? document.getElementById("tempText").clientWidth + 10
          : document.getElementById("tempText").clientWidth + 25,
      height: document.getElementById("tempText").clientHeight,
      Lineheight: document.getElementById("tempText").clientHeight + "px",
    };

    document.getElementById("tempText").remove();

    return textObj;
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const onButtonClick = (fontSize, height, TextString) => {
    const textObj = tempText(TextString, fontSize);

    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let percentage = 497 / 1024;
    fontSize = parseInt(fontSize * percentage);
    height = height * percentage;
    let _width = CanvasWidth * percentage;

    var top = getRandomArbitrary(0, canvasHeight - height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;
    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false;
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      if (LayersData[i].subtype === "watermark") {
        swal("info", "Watermark is Already Applied.", "info");
        return;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

    // var _slide = Array.from(slides);
    // for (let i = 0; i < _slide.length; i++) {
    let newEntryLayerData = {
      Added: true,
      key: checkKey + 1,
      type: "text",
      subtype: "watermark",
      spanHeight: "",
      spanWidth: "",
      scale: 1,
      bgColor: "#323232",
      Name: `watermark-${typelength}`,
      TextId: makeid(6),
      AnimationId: makeid(6),
      canvas: null,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      TimelineZoom: timelineZoomVal,
      duration: totalTime,
      startTime: currentTime,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      typeIcon: "text_fields",
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      originalX: null,
      transform: "translate(0px, 0px)",
      text: TextString,
      x: left,
      y: top,
      edit: "false",
      fontSize: fontSize,
      Align: "center",
      fontWeight: TextString == "ToonsRights" ? "bold" : "normal",
      Fontstyle: "calibri",
      textDec: "none",
      opacity: 0.5,
      width: textObj.width,
      height: textObj.height,
      toolbar: false,
      FurtherSetting: false,
      EditorZoom: EditorZoom,
      //LineHeight: textObj.Lineheight,
      LineHeight: 1.1,
      LetterSpacing: 0,
      textColor: "#333333",
      lock: false,
      layerlock: true,
      opc: 1, //its use for the eye on the timeline wrapper for lock
      hidden: false,
      Editable: true,
      startPositionOnTimeline: TickerPosition,
      rotateAngle: 0,
      googleFontSetting: {
        fontName: "Circular",
        fontFamily: "Circular",
        googleFontUrl: "../fonts/Circular/CircularStd-Medium.otf",
      },
      InMultiDrag: false,
      showDiv: true,
    };

    //1px is equal to 13.28ms and 15.06px is 200ms so 1s equals to 75.30px so now calculate width based on duration
    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    setLayersData(LayersData.concat(newEntryLayerData));

    //if(!_slide[i].LayerData.find(x=>x.subtype=="watermark"))
    //_slide[i].LayerData = _slide[i].LayerData.concat(newEntryLayerData);
    //setChangeCount(ChangeCount + 1);

    //ShowPanelLeft
    seteditableObject({ showPanel: true, editableItem: newEntryLayerData });
    //};
    //setslides(_slide);
  };

  const changingOpacity = (value) => {
    // const array = Array.from(LayersData);
    // for (let i = 0; i < array.length; i++) {
    //   if (array[i].key === values.key) {
    //     array[i].opacity = value / 100;
    //     array[i].originalOpacity = value / 100;
    //     break;
    //   }
    // }
    // setLayersData(array);
    setrangeValue(Math.trunc(value));
    setwatermark({ ...watermark, opacity: Math.trunc(value) });
  };

  function resizeImage(imgEl, wantedWidth) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const aspect = imgEl.width / imgEl.height;
    canvas.width = wantedWidth;
    canvas.height = wantedWidth / aspect;
    ctx.drawImage(imgEl, 0, 0, canvas.width - 20, canvas.height - 20 / aspect);
    return canvas.toDataURL();
  }

  const CreatePattern = (imageBase64, base64Canvas, resolve) => {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    canvas.width = 1920;
    canvas.height = 1080;

    var img = new Image();
    img.onload = start;
    img.src = imageBase64;
    function start() {
      var newURI = resizeImage(this, 100);
      var imgSmall = new Image();
      imgSmall.onload = function () {
        var patt = document.createElement("canvas");
        patt.id = "test";
        patt.width = imgSmall.naturalWidth;
        patt.height = imgSmall.naturalHeight;
        patt.getContext("2d").drawImage(this, 0, 0, patt.width, patt.height);

        var space = ctx.createPattern(patt, "repeat");
        ctx.fillStyle = space;
        ctx.fillRect(0, 0, 1920, 1065);
        base64Canvas = canvas.toDataURL("image/png");
        resolve(base64Canvas);
      };
      imgSmall.src = newURI;
    }
    // function scaleIt(source) {
    //   var c = document.createElement("canvas");
    //   var ctx = c.getContext("2d");
    //   var w = source.naturalWidth;
    //   var h = source.naturalHeight;
    //   c.width = w;
    //   c.height = h;
    //   ctx.drawImage(source, 0, 0, w, h);
    //   return c;
    // }
  };

  // function drawPattern(img, size) {
  //   var canvas = document.createElement("canvas");

  //   canvas.height = 1920;
  //   canvas.width = 1080;

  //   var tempCanvas = document.createElement("canvas"),
  //     tCtx = tempCanvas.getContext("2d");

  //   // tempCanvas.width = size;
  //   // tempCanvas.height = size;
  //   tempCanvas.width = 100;
  //   tempCanvas.height = img.height / (img.width / 100);
  //   tCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, size, size);

  //   // use getContext to use the canvas for drawing
  //   var ctx = canvas.getContext("2d");
  //   ctx.clearRect(0, 0, canvas.width, canvas.height);
  //   ctx.fillStyle = ctx.createPattern(tempCanvas, "repeat");

  //   ctx.beginPath();
  //   ctx.rect(0, 0, canvas.width, canvas.height);
  //   ctx.fill();
  //   var base64Canvas = canvas.toDataURL("image/png");
  //   setwatermark({
  //     ...watermark,
  //     pattern: base64Canvas,
  //   });
  // }
  const onSelectFile = async (e) => {
    // I've kept this example simple by using the first image instead of multiple
    //alert(e.target.files[0])
    let ratio = e.target.clientHeight / e.target.clientWidth;
    const objectUrl = URL.createObjectURL(e.target.files[0]);

    const imgBlob = await fetch(objectUrl).then((r) => r.blob());
    var reader = new FileReader();
    reader.readAsDataURL(imgBlob);
    reader.onloadend = function () {
      var base64data = reader.result;
      var canvasHeight =
        document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
      var CanvasWidth =
        document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

      let _width = e.target.clientHeight * ratio;
      let _height = e.target.clientHeight * ratio;

      //var height = parseInt(300 * (e.target.offsetHeight / 163))
      var top = getRandomArbitrary(0, canvasHeight - _height);
      var left = getRandomArbitrary(0, CanvasWidth - _width);
      //ImageClick(base64data, top, left, 160, 110, null, e);
      e.target.value = "";
      setlogoAdded(true);
      setlogoSrc(base64data);
      var base64Canvas = "";

      //base64Canvas = CreatePattern(base64data, base64Canvas);

      const myPromise = new Promise((resolve, reject) => {
        CreatePattern(base64data, base64Canvas, resolve);
      });
      myPromise.then((response) => {
        setwatermark({
          added: true,
          src: base64data,
          position: watermark.position,
          opacity: watermark.opacity,
          enabled: true,
          pattern: response,
        });
      });
    };
  };

  const ImageClick = (IUrl, ITop, ILeft, IWidth, Iheight, ImageBlob, event) => {
    var topIndex = 0;
    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var typelength = 1;
    var checkKey = 0;

    for (var i = 0; i < LayersData.length; i++) {
      LayersData[i].toolbar = false;
      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
        LayersData[i].showDiv = false;
      }
      if (LayersData[i].subtype === "watermark") {
        swal("info", "Watermark is Already Applied.", "info");
        return;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    // let TickPos;
    // let trans = document.getElementById('tickerHead').style.transform;
    // if (trans != "") {
    //   trans = trans.split('(')
    //   trans = trans[1].split(',')
    //   trans = trans[0].split('px')
    //   trans = eval(trans[0]);
    //   TickPos = trans
    // }

    let currentTime = calculateTimeByWidth(TickerPosition);
    let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);

    let newEntryLayerData = {
      AnimationId: makeid(6),
      Added: true,
      key: checkKey + 1,
      type: "image",
      subtype: "watermark",
      bgColor: "#554bf5",
      Name: `watermark-${typelength}`,
      canvas: null,
      video: null,
      TimelineZoom: timelineZoomVal,
      userFile: "xyz",
      layerIndex: topIndex,
      index: null,
      duration: totalTime,
      startTime: currentTime,
      EditorZoom: EditorZoom,
      originalX: null,
      endTime: calculateTimeByWidth(Tl_TotalTime.width),
      volume: null,
      visible: true,
      OutEffect: "none",
      InEffect: "none",
      InClass: "",
      OutClass: "",
      typeIcon: "vrpano",
      STdiff: null,
      startTransitionWidth: 0,
      startTransitionLeft: 0,
      endTransitionWidth: 0,
      endTransitionLeft: 0,
      angle: 0,
      ImageSrc: IUrl,
      crop: "false",
      lock: false,
      x: ILeft,
      y: ITop,
      flip: "scaleX(1)",
      width: IWidth,
      height: Iheight,
      toolbar: true,
      FurtherSetting: false,
      opacity: 0.5,
      originalOpacity: 0.5,
      layerlock: true,
      opc: 1,
      hidden: false,
      Editable: true,
      ImageBlob: ImageBlob,
      startPositionOnTimeline: TickerPosition,
      player: false,
      rotateAngle: 0,
      InMultiDrag: false,
      showDiv: true,
    };

    newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
      newEntryLayerData.duration
    );
    newEntryLayerData.endTransitionLeft =
      newEntryLayerData.widthOnTimeline - newEntryLayerData.endTransitionWidth;
    setLayersData(LayersData.concat(newEntryLayerData));
    seteditableObject({
      showPanel: true,
      editableItem: newEntryLayerData,
    });
  };

  const imageUpload = () => {
    ImageUploderRef.current.click();
  };

  return (
    <div id="textWrapper" className="innerWrapperPanel">
      <div className="templatesWrapper">
        <div className="divLabel mb-3">Watermark Settings</div>

        <div
          className="style-1 "
          style={{
            height: "calc(100% - 66px)",
            overflowY: "scroll",
            padding: "0px 12px",
          }}
        >
          {logoAdded == false && (
            <div className="watermarkpanel NotAdded">
              <div className="">
                <div
                  onClick={(e) => {
                    imageUpload();
                  }}
                  className="image_uploader_inner"
                  style={{ marginBottom: "10px" }}
                >
                  <div className="Image_uploader_text">
                    <div className="flex">
                      <span className="material-icons customBtnIcon">
                        upload
                      </span>
                      Upload Logo
                    </div>

                    <input
                      ref={ImageUploderRef}
                      hidden
                      type="file"
                      accept="image/png, image/jpeg"
                      onChange={onSelectFile}
                    ></input>
                  </div>
                </div>
              </div>
              <label>
                Currently there is no watermark added. Upload your logo to add
                as watermark.
              </label>
            </div>
          )}
          {logoAdded && (
            <div className="watermarkpanel Added">
              <div className="Note">
                <strong>Note: </strong>Watermark will be shown in preview
              </div>
              <div className="watermarkWrapper">
                <img src={logoSrc} id="logoImage" />
              </div>
              <div className="d-flex watermarkOptions mb-4">
                <div className="Left">
                  <div className="settingsTitle bolderFont mr-3">
                    Enable Watermark:
                  </div>
                  <label className="switch customCheckBox">
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setwatermark({
                          ...watermark,
                          enabled: e.target.checked,
                        });
                      }}
                      checked={watermark.enabled}
                    />
                  </label>
                </div>
                <div className="Right">
                  <button
                    onClick={(e) => {
                      imageUpload();
                    }}
                    className="btn btn-small btn-danger mr-2"
                  >
                    Change
                  </button>
                  <input
                    ref={ImageUploderRef}
                    hidden
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={onSelectFile}
                  ></input>
                </div>
              </div>

              <div className="watermarkPostionWrapper">
                <label>
                  Watermark Postion:
                  <strong className="strong">"{watermark.position}"</strong>
                </label>
                <div className="d-flex">
                  <div className="postioningPanel">
                    <div
                      className={
                        watermark.position === "Top Left"
                          ? "topLeft active"
                          : "topLeft"
                      }
                      onClick={() =>
                        setwatermark({ ...watermark, position: "Top Left" })
                      }
                    ></div>
                    <div
                      className={
                        watermark.position === "Top Right"
                          ? "topRight active"
                          : "topRight"
                      }
                      onClick={() =>
                        setwatermark({ ...watermark, position: "Top Right" })
                      }
                    ></div>
                    <div
                      className={
                        watermark.position === "Bottom Left"
                          ? "bottomLeft active"
                          : "bottomLeft"
                      }
                      onClick={() =>
                        setwatermark({ ...watermark, position: "Bottom Left" })
                      }
                    ></div>
                    <div
                      className={
                        watermark.position === "Bottom Right"
                          ? "bottomRight active"
                          : "bottomRight"
                      }
                      onClick={() =>
                        setwatermark({ ...watermark, position: "Bottom Right" })
                      }
                    ></div>
                    <div
                      className={
                        watermark.position === "Center"
                          ? "center active"
                          : "center"
                      }
                      onClick={() =>
                        setwatermark({ ...watermark, position: "Center" })
                      }
                    ></div>
                  </div>
                  <div
                    className="postioningPattern ml-3"
                    onClick={() =>
                      setwatermark({ ...watermark, position: "Pattern" })
                    }
                    style={{
                      borderColor:
                        watermark.position === "Pattern"
                          ? "#0281ff"
                          : "#eeeeee",
                    }}
                  ></div>
                </div>
              </div>

              <div className="watermarkOpacity mt-4">
                <div className="LabelWithSlider Transparency">
                  <label>Transparency</label>
                  <div className="opacitySlider">
                    <div className="rangeSlider">
                      <InputRange
                        maxValue={100}
                        minValue={0}
                        value={rangeValue}
                        onChange={(value) => changingOpacity(value)}
                      />
                    </div>
                    <div className="opacityValue">{Math.round(rangeValue)}</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Wmark;

{
  /* <Button
            style={{
              marginTop: "10px",
              marginLeft: "10px",
              background: "#296AFF",
              width: "90%",
            }}
            onClick={(e) => {
              onButtonClick(220, 220, "ToonsRights");
            }}
            variant="contained"
            color="success"
          >
            Text Water Mark
          </Button> */
}
